import {
    Button,
    Grid,
    Typography
}                        from "@mui/material";
import React, {
    useEffect,
    useRef,
    useState
}                        from "react";
import {
    AddControle,
    Controle,
    ControleDetail,
    DeactivateControleCommand,
    Delete,
    IGStyle,
    Note,
    PerformControle,
    PerformControleCommand,
    UpdateControle
} from "../../constants";
import {useGobesContext} from "../../context/GobesContextProvider";
import {submitObject}    from "../../util";

const ControleBlock = () =>
{
    const {
        selectedCompanyRecord,
        setFormData,
        setModalVisible, companyDetails,setDeleteCallback,
        setModalAction,
        refreshResource, setRefreshResource, setAlertVisible, setAlertText, selectedEnergyRecord
    } = useGobesContext()

    const RMRef = useRef<any>()
    const RDRef = useRef<any>()
    const [detailStatus, setDetailStatus] = useState<any>(false)
    const [detailRecord, setDetailRecord] = useState<any>("")

    useEffect(() =>
    {
        RMRef.current.defaultSortField = "datum"
        RMRef.current.defaultSortDirection = "DESCENDING"

        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setFormData(event.detail.record)
            setDetailStatus(true)
            setDetailRecord(event.detail.recordId)
        })
    }, [])

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case Controle:
                setTimeout(() => {
                    RMRef.current?.refresh()

                }, 1000)
                break
            case ControleDetail:
                setTimeout(() => RDRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function ResetDetailStatus()
    {
        setRefreshResource(Controle)
        setDetailStatus(false)
    }

    function AddObject()
    {
        setFormData(RMRef.current?.data)

        setModalVisible(true)
        setModalAction(AddControle)
    }

    function EditObject()
    {
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(UpdateControle)
    }

    function DeleteObject()
    {
        submitObject({id: RDRef.current?.data.id}, companyDetails?.id, DeactivateControleCommand).then(async (event: any) =>
        {
            HandleSubmit(event)
        })

        setDetailStatus(false)
        setRefreshResource(Controle)
    }

    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status !== 200)
        {
            const response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }
    }

    const handleStartDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
        setModalVisible(true)
        setModalAction(Delete)
        setDeleteCallback({delete: DeleteObject} )
    };

    function PerformCheckControl(){

        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(PerformControle)

        // submitObject({id: RDRef.current?.data.id}, companyDetails?.id, PerformControleCommand).then(async (event: any) =>
        // {
        //     HandleSubmit(event)
        // })
        //
        // setDetailStatus(false)
        // setRefreshResource(Controle)
    }

    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Controles
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>
                    <div style={{
                        display: detailStatus
                                 ? "contents"
                                 : "none"
                    }}>
                        <Button onClick={ResetDetailStatus}>Back</Button>
                        {/*// @ts-ignore*/}
                        <ig-resource-detail lang="nl-NL" ref={RDRef} class={"ig-detail-remove-2rows"} style={IGStyle} resource-detail-id="ControleRD" resource-id={detailRecord}/>
                    </div>
                    <div style={{
                        display: detailStatus
                                 ? "none"
                                 : "contents"
                    }}> {/*// @ts-ignore*/}
                        <ig-resource-master lang="nl-NL" ref={RMRef} style={IGStyle} class={"ig-columns"} resource-master-id="ControleRM" dsl-filter={selectedEnergyRecord}/>
                    </div>

                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid container item xs={4}>
                        <Grid container direction="column" item>
                            <Button variant={"contained"} disabled={detailStatus} onClick={AddObject}>Controle Uitvoeren</Button>
                            <Button variant={"contained"} disabled={!detailStatus} onClick={EditObject}>Controle Bewerken</Button>
                            <Button variant={"contained"} disabled={!detailStatus} onClick={handleStartDelete}>Controle Verwijderen</Button>
                            <Button variant={"contained"} disabled={!detailStatus} onClick={PerformCheckControl}>Hercontrole Uitvoeren</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default ControleBlock